/**
 * AsyncEventQueue — bridges callback-style producers (transcript tailer, hook
 * socket) into a single async-generator consumer.  Producers call `push`;
 * the consumer drains via the async generator returned by `drain()`.
 */
export class AsyncEventQueue<T> {
  private readonly items: T[] = [];
  private closed = false;
  private wake: (() => void) | null = null;

  push(item: T): void {
    if (this.closed) return;
    this.items.push(item);
    this.signal();
  }

  close(): void {
    this.closed = true;
    this.signal();
  }

  get isClosed(): boolean {
    return this.closed;
  }

  private signal(): void {
    const wake = this.wake;
    if (wake) {
      this.wake = null;
      wake();
    }
  }

  async *drain(): AsyncGenerator<T, void> {
    while (!this.closed || this.items.length > 0) {
      if (this.items.length > 0) {
        const item = this.items.shift();
        if (item !== undefined) yield item;
        continue;
      }
      await new Promise<void>((resolve) => {
        this.wake = resolve;
      });
    }
  }
}
